import { positionCode } from "./layout";
const tyreAt = (vehicle, ref) => {
  var _a;
  return (_a = vehicle.tyres[positionCode(ref)]) != null ? _a : null;
};
const isFitted = (vehicle, ref) => tyreAt(vehicle, ref) !== null;
export {
  isFitted,
  tyreAt
};
